import type CodeMirror from 'codemirror'
import { kdpMetrics, metrics, operators, properties } from './common'

const prefixes = (values: string[]): Record<string, string[]> =>
    [...values]
        .sort((a, b) => b.length - a.length)
        .reduce<Record<string, string[]>>((result, value) => {
            const first = value.slice(0, 1)
            result[first] ??= []
            result[first].push(value.slice(1))
            return result
        }, {})

const propertyPrefixes = prefixes(properties)
const operatorPrefixes = prefixes(operators)
const metricPrefixes = prefixes(metrics)
const kdpMetricPrefixes = prefixes([...metrics, ...kdpMetrics])

const matchesPrefix = (
    ch: string | null,
    stream: CodeMirror.StringStream,
    candidates: Record<string, string[]>,
) => candidates[ch ?? '']?.some((candidate) => stream.match(candidate)) ?? false

export const isProperty = (ch: string | null, stream: CodeMirror.StringStream) =>
    matchesPrefix(ch, stream, propertyPrefixes)

export const isMetric = (isKdp: boolean, ch: string | null, stream: CodeMirror.StringStream) =>
    matchesPrefix(ch, stream, isKdp ? kdpMetricPrefixes : metricPrefixes)

export const isOperator = (ch: string | null, stream: CodeMirror.StringStream) =>
    matchesPrefix(ch, stream, operatorPrefixes)

export const isNumber = (ch: string | null, stream: CodeMirror.StringStream) => {
    if (!(ch === '$' || /\d/.test(ch ?? ''))) return false
    return stream.match(/^[\d]*(?:\.[\d]*)?[%]?/)
}

export const isDate = (_ch: string | null, stream: CodeMirror.StringStream) =>
    stream.match(/\d\d\d\d-\d\d-\d\d/)

export const isRelativeDate = (_ch: string | null, stream: CodeMirror.StringStream) =>
    stream.match(/\d+ days ago/)

export const isStringValue = (ch: string | null, stream: CodeMirror.StringStream) => {
    switch (ch) {
        case 'e':
            return !!(
                stream.match('nabled') ||
                stream.match('ffectively enabled') ||
                stream.match('ffectively running') ||
                stream.match('ffectively active') ||
                stream.match('ffectively paused') ||
                stream.match('ffectively archive')
            )
        case 'a':
            return !!(stream.match('ctive') || stream.match('rchived'))
        case 'r':
            return !!stream.match('unning')
        case 'p':
            return !!stream.match('aused')
        case '"':
            return stream.match(/.*?"/)
        default:
            return false
    }
}
